import React, { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import { CloseIcon } from "@chakra-ui/icons";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";

const images = [
  {
    original: "/assets/pratos-inspire/aline-dias.png",
    thumbnail: "/assets/pratos-inspire/aline-dias.png",
  },
  {
    original: "/assets/pratos-inspire/anna-crizologo.png",
    thumbnail: "/assets/pratos-inspire/anna-crizologo.png",
  },
  {
    original: "/assets/pratos-inspire/bruno-lyfe.png",
    thumbnail: "/assets/pratos-inspire/bruno-lyfe.png",
  },
  {
    original: "/assets/pratos-inspire/marina-celestino.png",
    thumbnail: "/assets/pratos-inspire/marina-celestino.png",
  },
  {
    original: "/assets/pratos-inspire/padhyma-padhy.png",
    thumbnail: "/assets/pratos-inspire/padhyma-padhy.png",
  },
  {
    original: "/assets/pratos-inspire/ricardo-vianna.png",
    thumbnail: "/assets/pratos-inspire/ricardo-vianna.png",
  },
  {
    original: "/assets/pratos-inspire/rodrigo-doin.png",
    thumbnail: "/assets/pratos-inspire/rodrigo-doin.png",
  },
  {
    original: "/assets/pratos-inspire/victoria-espigoti.png",
    thumbnail: "/assets/pratos-inspire/victoria-espigoti.png",
  },
];

const GaleryCourtine = ({ onClose }) => {
  const [animStarted, setAnimStarted] = useState(false);

  useEffect(() => {
    setAnimStarted(true);
  }, []);

  return (
    <Box
      pos="fixed"
      top="0"
      left="0"
      zIndex="99999999999999999"
      height="100vh"
      w="100%"
      bg="rgba(0,0,0,0.6)"
    >
      <Box
        h="100%"
        w="100%"
        bg="rgba(0,0,0,0.95)"
        opacity={animStarted ? 1 : 0}
        transform={animStarted ? "translateY(0)" : "translateY(-100%)"}
        transition="0.7s ease-in-out"
        overflow="auto"
      >
        <CloseIcon
          pos="absolute"
          top="40px"
          right="50px"
          fontSize="50px"
          color="#fff"
          cursor="pointer"
          onClick={onClose}
        />
        <Box maxW="80%" mx="auto" mt={["150px", null, null, "30px"]}>
          <ImageGallery items={images} />;
        </Box>
      </Box>
    </Box>
  );
};

export default GaleryCourtine;
